<template>
  <div class="card mb-25 bg-white add-user-card produit-form">
    <div class="card-header">
      <h3 class="text-black fw-semibold mb-1">Ajouter un produit</h3>
      <p class="text-muted mb-0 small">Les champs marqués <span class="text-danger">*</span> sont obligatoires.</p>
    </div>
    <div class="card-body letter-spacing">
      <Form ref="produitForm" @submit="addProduit" :keep-values="valuess" :validation-schema="produitSchema">

        <!-- ===== 1. Identification ===== -->
        <section class="form-section">
          <h6 class="section-title">Identification</h6>
          <div class="row g-3">
            <div class="col-lg-3 col-md-4">
              <label class="form-label-produit">Image principale</label>
              <div class="upload-container">
                <input type="file" ref="fileInput" @change="(event) => onFilePrinChange(event)"
                  accept="image/jpeg, image/png, image/jpg" hidden />
                <!-- Carte d'aperçu (cliquable pour choisir une image) -->
                <div class="preview-card" @click="triggerFileInput">
                  <img v-if="imagePreview" :src="imagePreview" alt="Image preview" />
                  <div v-else class="text-center px-3">
                    <i class="fa fa-camera preview-icon"></i>
                    <div class="fw-medium mt-2">Ajouter une image</div>
                    <small class="text-muted">JPG ou PNG</small>
                  </div>
                  <!-- Bouton de suppression sur l'image -->
                  <button v-if="imagePreview" type="button" class="delete-btn" title="Retirer l'image"
                    @click.stop="removeImage"><i class="fa fa-times"></i></button>
                </div>
              </div>
            </div>

            <div class="col-lg-9 col-md-8">
              <div class="row g-3">
                <div class="col-md-3">
                  <label class="form-label-produit">Code du produit</label>
                  <Field type="text" name="code" class="form-control shadow-none text-black bg-light"
                    readonly="true" placeholder="Généré automatiquement" />
                  <ErrorMessage name="code" class="text-danger small" />
                </div>
                <div class="col-md-3">
                  <label class="form-label-produit">Référence usine</label>
                  <Field name="refProd" type="text" class="form-control shadow-none text-black"
                    placeholder="Entrer la référence" />
                  <ErrorMessage name="refProd" class="text-danger small" />
                </div>
                <div class="col-md-6">
                  <label class="form-label-produit">Famille <span class="text-danger">*</span></label>
                  <Field name="famille" v-slot="{ field }">
                    <Multiselect :options="familleOptions" :searchable="true" track-by="label" label="label"
                      v-model="field.value" v-bind="field" @select="selectFamille(field.value)"
                      placeholder="Sélectionner la famille" />
                  </Field>
                  <ErrorMessage name="famille" class="text-danger small" />
                </div>

                <div class="col-md-4 position-relative" ref="dropdownRef">
                  <label class="form-label-produit">Nom du produit <span class="text-danger">*</span></label>
                  <Field name="nomProd" type="text" v-model="prodName" @focus="showBox = true"
                    class="form-control shadow-none text-black" placeholder="Entrer le nom du produit" />
                  <ul class="dropdown-menu show suggestions" v-if="produitOptions.length > 0 && showBox == true">
                    <li v-for="(produit, index) in produitOptions" :key="index">
                      <a class="dropdown-item" href="javascript:void(0);">{{ produit.codeProduit }} - {{
                        produit.nomProd }}</a>
                    </li>
                  </ul>
                  <ErrorMessage name="nomProd" class="text-danger small" />
                </div>
                <div class="col-md-4 position-relative" ref="dropdownRef1">
                  <label class="form-label-produit">Nom standard</label>
                  <Field name="nomStandar" type="text" v-model="prodNameS" @focus="showBoxStan = true"
                    class="form-control shadow-none text-black" placeholder="Entrer le nom standard" />
                  <ul class="dropdown-menu show suggestions" v-if="produitStanOptions.length > 0 && showBoxStan == true">
                    <li v-for="(produit, index) in produitStanOptions" :key="index">
                      <a class="dropdown-item" href="javascript:void(0);">{{ produit.codeProduit }} - {{
                        produit.nomProd }}</a>
                    </li>
                  </ul>
                  <ErrorMessage name="nomStandar" class="text-danger small" />
                </div>
                <div class="col-md-4 position-relative" ref="dropdownRef2">
                  <label class="form-label-produit">Nom marché</label>
                  <Field name="nomMarche" type="text" v-model="prodNameM" @focus="showBoxM = true"
                    class="form-control shadow-none text-black" placeholder="Entrer le nom marché" />
                  <ul class="dropdown-menu show suggestions" v-if="produitMarOptions.length > 0 && showBoxM == true">
                    <li v-for="(produit, index) in produitMarOptions" :key="index">
                      <a class="dropdown-item" href="javascript:void(0);">{{ produit.codeProduit }} - {{
                        produit.nomProd }}</a>
                    </li>
                  </ul>
                  <ErrorMessage name="nomMarche" class="text-danger small" />
                </div>

                <div class="col-md-6">
                  <label class="form-label-produit">Unité de stockage</label>
                  <Field name="uniteStock" v-slot="{ field }" v-model="uniteStock">
                    <Multiselect :options="conditionnementOptions" :searchable="true" track-by="label" label="label"
                      v-model="field.value" v-bind="field" placeholder="Choisir l'unité de stockage" />
                  </Field>
                  <ErrorMessage name="uniteStock" class="text-danger small" />
                </div>
                <div class="col-md-6">
                  <label class="form-label-produit">Unité de gestion</label>
                  <Field name="uniteGestion" v-slot="{ field }" v-model="uniteGestion">
                    <Multiselect :options="conditionnementgOptions" :searchable="true" track-by="label"
                      label="label" v-model="field.value" v-bind="field" @select="seletUniteGestion(field.value)"
                      placeholder="Choisir l'unité de gestion" />
                  </Field>
                  <ErrorMessage name="uniteGestion" class="text-danger small" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- ===== 2. Gestion du stock ===== -->
        <section class="form-section">
          <h6 class="section-title">Gestion du stock</h6>
          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label-produit">Méthode de suivi de stock <span class="text-danger">*</span></label>
              <Field name="suiviStock" type="text" v-slot="{ field }">
                <Multiselect :searchable="true" :options="['CUMP', 'FIFO', 'LIFO', 'Par lot']" v-model="field.value"
                  v-bind="field" placeholder="Sélectionner la méthode" />
              </Field>
              <ErrorMessage name="suiviStock" class="text-danger small" />
            </div>
            <div class="col-md-4">
              <label class="form-label-produit">Seuil d'alerte <span class="text-danger">*</span></label>
              <Field name="seuilAlerte" type="number" class="form-control shadow-none text-black"
                placeholder="Ex. 10" />
              <ErrorMessage name="seuilAlerte" class="text-danger small" />
            </div>
            <div class="col-md-4">
              <label class="form-label-produit">Seuil de rupture <span class="text-danger">*</span></label>
              <Field name="seuilAppro" type="number" class="form-control shadow-none text-black"
                placeholder="Ex. 2" />
              <ErrorMessage name="seuilAppro" class="text-danger small" />
            </div>
          </div>
        </section>

        <!-- ===== 3. Classification et fiscalité ===== -->
        <section class="form-section">
          <h6 class="section-title">Classification et fiscalité</h6>
          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label-produit">Pays de fabrication <span class="text-danger">*</span></label>
              <Field name="paysProduction" type="text" v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" :options="pays" :searchable="true"
                  placeholder="Sélectionner le pays" label="label" track-by="label" />
              </Field>
              <ErrorMessage name="paysProduction" class="text-danger small" />
            </div>
            <div class="col-md-4">
              <label class="form-label-produit">Groupe de taxe <span class="text-danger">*</span></label>
              <Field name="groupe" v-model="groupe" v-slot="{ field }">
                <Multiselect :options="groupeOptions" :searchable="true" track-by="value" label="label"
                  v-model="groupe" v-bind="field" placeholder="Sélectionner un groupe" @select="onGroupeSelect" />
              </Field>
              <ErrorMessage name="groupe" class="text-danger small" />
            </div>
            <div class="col-md-4">
              <label class="form-label-produit">Mode de définition du prix <span class="text-danger">*</span></label>
              <Field name="mode" v-model="mode" :readonly="estRedonly" v-slot="{ field }">
                <Multiselect :options="modeOptions" :searchable="true" track-by="value" label="label"
                  v-model="mode" :disabled="estRedonly" placeholder="Sélectionner le mode"
                  @select="(val) => { mode = val }" />
              </Field>
              <ErrorMessage name="mode" class="text-danger small" />
            </div>
          </div>
        </section>

        <!-- ===== 4. Description et champs complémentaires ===== -->
        <section class="form-section">
          <h6 class="section-title">Description</h6>
          <div class="row g-3">
            <div class="col-12">
              <label class="form-label-produit">Description du produit</label>
              <Field name="descProd" as="textarea" placeholder="Entrer la description" v-slot="{ field }"
                class="form-control shadow-none text-black">
                <textarea class="form-control shadow-none text-black" rows="3" v-model="field.value"
                  placeholder="Entrer la description"></textarea>
              </Field>
              <ErrorMessage name="descProd" class="text-danger small" />
            </div>

            <div class="col-md-3" v-for="(champsLibre, index) in chamsdescritifs" :key="index">
              <label class="form-label-produit">
                {{ champsLibre.libelleChamp }} <span class="text-danger" v-if="champsLibre.estObligatoire == 1">*</span>
              </label>
              <div v-if="champsLibre.typeChamp == 'boolean'" class="d-flex gap-3 pt-1">
                <label class="d-flex align-items-center gap-1">
                  <input type="radio" v-model="champsLibre.valeur"
                    :class="(valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-check-input is-invalid' : 'form-check-input'"
                    name="status" value="1" checked> Oui
                </label>
                <label class="d-flex align-items-center gap-1">
                  <input type="radio" v-model="champsLibre.valeur"
                    :class="(valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-check-input is-invalid' : 'form-check-input'"
                    name="status" value="0"> Non
                </label>
              </div>
              <div v-else-if="champsLibre.typeChamp == 'name'">
                <select v-if="champsLibre.modeSaisie == 'keywordValueList'"
                  :class="(valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-select shadow-none text-black is-invalid ' : 'form-select shadow-none text-black '"
                  v-model="champsLibre.valeur" :name="champsLibre.nomChamp">
                  <option value="" disabled>Sélectionner</option>
                  <option v-for="(option, index) in champsLibre.valeurPossible" :key="index" :value="option.value">
                    {{ option.libelle }}
                  </option>
                </select>
                <select v-if="champsLibre.modeSaisie == 'keywordKeyValueList'"
                  :class="(valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-select shadow-none text-black is-invalid ' : 'form-select shadow-none text-black '"
                  v-model="champsLibre.valeur" :name="champsLibre.nomChamp">
                  <option value="" disabled>Sélectionner</option>
                  <option v-for="(option, index) in champsLibre.valeurPossible" :key="index" :value="option.valeur">
                    {{ option.libelle }}
                  </option>
                </select>
              </div>
              <input v-else
                :class="(valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-control shadow-none text-black is-invalid ' : 'form-control shadow-none text-black '"
                v-model="champsLibre.valeur" :name="champsLibre.nomChamp" :type="champsLibre.typeChamp" />
              <div v-if="valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1"
                class="text-danger small">
                {{ champsLibre.libelleChamp }} est obligatoire.
              </div>
            </div>
          </div>
        </section>

        <!-- ===== 5. Conditionnements et images ===== -->
        <section class="form-section">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane"
                type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">
                <i class="fa fa-cubes me-1"></i> Conditionnements
                <span class="badge bg-light text-dark ms-1">{{ conditionnements.length }}</span>
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="home2-tab" data-bs-toggle="tab" data-bs-target="#home2-tab-pane"
                type="button" role="tab" aria-controls="home2-tab-pane" aria-selected="false">
                <i class="fa fa-picture-o me-1"></i> Images
              </button>
            </li>
          </ul>

          <div class="tab-content tab-cadre" id="myTabContent">
            <!-- Conditionnements -->
            <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" tabindex="0">
              <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                <p class="text-muted small mb-0">
                  La première ligne correspond à l'unité de gestion. Ajoutez les autres conditionnements de vente.
                </p>
                <button class="btn btn-outline-primary btn-sm" type="button"
                  :class="{ 'cursor-not-allowed': isDisable }" :disabled="isDisable"
                  @click="addRowConditionnement()">
                  <i class="fa fa-plus me-1"></i> Ajouter un conditionnement
                </button>
              </div>

              <div class="cond-grid">
                <div class="row gx-2 cond-entete d-none d-md-flex">
                  <div class="col-md-2">Conditionnement <span class="text-danger">*</span></div>
                  <div class="col-md-2">Quantité <span class="text-danger">*</span></div>
                  <div class="col-md-2">Prix min <span class="text-danger">*</span></div>
                  <div class="col-md-2">Prix de vente <span class="text-danger">*</span></div>
                  <div class="col-md-2">Prix max <span class="text-danger">*</span></div>
                  <div class="col-md-2 text-end">Action</div>
                </div>

                <div class="row gx-2 cond-ligne" v-for="(conditionnement, index) in conditionnements" :key="index">
                  <div class="col-md-2">
                    <input v-if="index == 0" type="text" readonly :value="uniteGestion?.split('|')[2]"
                      class="form-control shadow-none text-black bg-light" />
                    <Multiselect v-else :options="conditionnementOptions" :searchable="true" track-by="label"
                      label="label" v-model="conditionnement.conditionnement" placeholder="Sélectionner"
                      @select="selectConditionnement(conditionnement.conditionnement, conditionnement)" />
                    <div class="invalid-feedback d-block" v-if="valideteRowProduit(conditionnement.conditionnement)">
                      Le conditionnement est obligatoire.
                    </div>
                  </div>

                  <div class="col-md-2">
                    <input v-if="index == 0" type="text" readonly v-model="conditionnement.quantite"
                      class="form-control shadow-none text-black bg-light" />
                    <div class="input-group" v-else>
                      <input type="number" v-model="conditionnement.quantite" :class="valideteRowProduit(conditionnement.quantite)
                        ? 'form-control shadow-none text-black is-invalid '
                        : 'form-control shadow-none text-black '" placeholder="Quantité" />
                      <span class="input-group-text">{{ uniteGestion != null
                        ? (uniteGestion?.split("|")[2]) : 'UM' }}</span>
                    </div>
                    <div v-if="valideteRowProduit(conditionnement.quantite)" class="invalid-feedback d-block">
                      La quantité est obligatoire.
                    </div>
                  </div>

                  <div class="col-md-2">
                    <input v-if="index == 0" type="text" v-model="conditionnement.prixMin"
                      class="form-control shadow-none text-black" placeholder="Prix min" />
                    <input v-else type="number" v-model="conditionnement.prixMin"
                      :class="isPrixMinInvalid(conditionnement)
                        ? 'form-control shadow-none text-black is-invalid'
                        : 'form-control shadow-none text-black'"
                      placeholder="Prix min" />
                    <div v-if="isPrixMinInvalid(conditionnement)" class="invalid-feedback d-block">
                      Doit être inférieur ou égal au prix de vente.
                    </div>
                    <div v-if="valideteRowProduit(conditionnement.prixMin)" class="invalid-feedback d-block">
                      Le prix minimal est obligatoire.
                    </div>
                  </div>

                  <div class="col-md-2">
                    <input v-if="index == 0" type="text" v-model="conditionnement.prixVente"
                      @input="calculePrix(conditionnement.prixVente, conditionnement)"
                      class="form-control shadow-none text-black" placeholder="Prix de vente" />
                    <input v-else type="number" v-model="conditionnement.prixVente"
                      @input="calculePrix(conditionnement.prixVente, conditionnement)"
                      :class="valideteRowProduit(conditionnement.prixVente)
                        ? 'form-control shadow-none text-black is-invalid '
                        : 'form-control shadow-none text-black '"
                      placeholder="Prix de vente" />
                    <div v-if="valideteRowProduit(conditionnement.prixVente)" class="invalid-feedback d-block">
                      Le prix de vente est obligatoire.
                    </div>
                  </div>

                  <div class="col-md-2">
                    <input v-if="index == 0" type="text" v-model="conditionnement.prixMax"
                      class="form-control shadow-none text-black" placeholder="Prix max" />
                    <input v-else type="number" v-model="conditionnement.prixMax"
                      :class="isPrixMaxInvalid(conditionnement)
                        ? 'form-control shadow-none text-black is-invalid'
                        : 'form-control shadow-none text-black '"
                      placeholder="Prix max" />
                    <div v-if="isPrixMaxInvalid(conditionnement)" class="invalid-feedback d-block">
                      Doit être supérieur ou égal au prix de vente.
                    </div>
                    <div v-if="valideteRowProduit(conditionnement.prixMax)" class="invalid-feedback d-block">
                      Le prix maximal est obligatoire.
                    </div>
                  </div>

                  <div class="col-md-2 text-end">
                    <button v-if="index > 0" class="btn btn-outline-danger btn-sm" type="button"
                      title="Supprimer ce conditionnement" @click="removeRowConditionnement(index)">
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Images -->
            <div class="tab-pane fade" id="home2-tab-pane" role="tabpanel" tabindex="0">
              <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                <p class="text-muted small mb-0">Images supplémentaires du produit.</p>
                <button class="btn btn-outline-primary btn-sm" type="button"
                  :class="{ 'cursor-not-allowed': isDisablee }" :disabled="isDisablee" @click="addRowImage()">
                  <i class="fa fa-plus me-1"></i> Ajouter une image
                </button>
              </div>
              <div class="product-upload">
                <div class="dz-message needsclick">
                  <DropZone name="fichiers[]" :maxFilesize="50000000" :maxFiles="Number(10000000000)" class=""
                    :uploadOnDrop="true" @addedFile="onFileAdd" @removedFile="onFileRemove"
                    :options="dropzoneOptions" @vdropzone-success="onSuccess" @vdropzone-error="onError">
                    <div class="default-image-container" v-if="!hasFiles">
                      <img :src="defaultImage" alt="Default" class="default-image" />
                      <p class="text-muted mb-0">Glissez-déposez vos images ici, ou cliquez pour les sélectionner</p>
                    </div>
                  </DropZone>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- ===== Actions ===== -->
        <div class="form-actions">
          <router-link to="/produits/liste-produits" class="btn btn-light">
            <i class="fa fa-arrow-left me-1"></i> Annuler
          </router-link>
          <button class="btn btn-primary" type="submit" :disabled="(isDisable || isDisableCha) ? true : false"
            :class="(!isDisable || !isDisableCha) ? { 'cursor-not-allowed': false } : { 'cursor-not-allowed': true }">
            <i class="fa fa-check me-1"></i> Enregistrer le produit
          </button>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted, reactive, onBeforeUnmount } from "vue";
import { Form, Field, ErrorMessage, useFieldArray, useForm } from "vee-validate";
import { error, success } from "@/utils/utils";
import { useRouter, useRoute } from "vue-router";

import ApiService from "@/services/ApiService";
import { Produit } from "@/models/Produit";
import * as Yup from "yup";
import axios from "axios";
import Multiselect from "@vueform/multiselect";
import DropZone from "dropzone-vue";
import { ChampsLibre } from "@/models/ChampsLibre";


export default defineComponent({
  name: "AddProduit",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
    DropZone
  },
  setup: () => {
    const produitForm = ref<Produit | null>(null);
    const router = useRouter();
    const route = useRoute();
    const familleOptions = ref([]);
    const groupeTaxeOptions = ref([]);
    const famille = ref();
    const marqueOptions = ref([]);
    const modeDefPrixOptions = ref([]);
    const produitStanOptions = ref([]);
    const produitMarOptions = ref([]);
    const prodName = ref("");
    const prodNameS = ref("");
    const prodNameM = ref("");
    //const magasinOptions = ref([]);
    const methodeOptions = ref([]);
    //const estService = ref(false);
    const isDisableCha = ref(false);
    const defaultImage = 'path/to/your/default-image.jpg'; 
    const hasFiles = ref(false); 
    const toutFichier = ref<Array<File>>([])
    const conditionnementOptions = ref([]);
    const conditionnementgOptions = ref([]);
    const produitOptions = ref([]);
    const domaineOptions = ref([]);
    const prixProd = ref();
    const produitsss: any = ref(null);
    const valuess = ref();
    const showBox = ref(false);
    const showBoxM = ref(false);
    const showBoxStan = ref(false);
    const chamsdescritifs = reactive<Array<ChampsLibre>>([]);
    const codeProduit = ref("");
    const uniteStock = ref(null);
    const groupeOptions = ref([]);
    const estRedonly = ref(true);
    const modeOptions = ref([
      { value: 'HT', label: 'HT' },
      { value: 'TTC', label: 'TTC' },
    ]);

    const mode =ref('');
    const groupe =ref('');




    const dropzoneOptions = {
      url: 'your-upload-url',
      thumbnailWidth: 150,
      maxFilesize: 2,
      headers: { "My-Awesome-Header": "header value" }
    };

    const onSuccess = (file) => {
      hasFiles.value = true; 
    };

    const onError = (file, message) => {
      console.error('File upload error:', message);
    };

    // watch(estService, () => {
    //   console.log('estservice', estService.value)
    // })

    watch(prodName, (newValue, oldValue) => {
      if (newValue != "" && newValue.length >= 3) {
        fetchProduis(newValue);
      } else {
        produitOptions.value = [];
      }
    })

    watch(prodNameS, (newValue, oldValue) => {
      if (newValue != "" && newValue.length >= 3) {
        fetchSProduis(newValue);
      } else {
        produitStanOptions.value = [];
      }
    })

    watch(prodNameM, (newValue, oldValue) => {
      if (newValue != "" && newValue.length >= 3) {
        fetchMProduis(newValue);
      } else {
        produitMarOptions.value = [];
      }
    })


    const montantTotal = ref(0);
    const isDisable = ref(true);
    const isDisablee = ref(true);
    const conditionnements = reactive([]);

    const images = reactive([
      {
        file: null,
        previewUrl: null,
      },
    ]);

    const addRowConditionnement = () => {
      conditionnements.push({
        conditionnement: "",
        quantite: 0,
        prixMin:null,
        prixVente:null,
        prixMax:null,
        conditionnement2: ""
      });
    };

    const onFileAdd = (file: any) => {
      toutFichier.value.push(file["file"]);
    };

    const onFileRemove = (file: File) => {
      //
      console.log("J'ai retiré ceci ==> ", file);
      console.log("LLLL ==> ", file["file"].name);
      console.log("TOUS FICHIERS ==> ", toutFichier.value);
      // Recherche de l'index du fichier dans le tableau
      const index = toutFichier.value.findIndex(fil => ((fil.name === file["file"].name) && (fil.size === file["file"].size) && (fil.type === file["file"].type)));
      if (index !== -1) {
        toutFichier.value.splice(index, 1);
      } else {
        console.log(`Le fichier ${file["file"].name} n'a pas été trouvé dans le tableau.`);
      }
    }

    const dropdownRef = ref(null);
    const dropdownRef1 = ref(null);
    const dropdownRef2 = ref(null);

    function handleClickOutside(event) {
      if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
        showBox.value = false;
      }

      if (dropdownRef1.value && !dropdownRef1.value.contains(event.target)) {
        showBoxStan.value = false;
      }

      if (dropdownRef2.value && !dropdownRef2.value.contains(event.target)) {
        showBoxM.value = false;
      }
    }

    const onFileChange = (event, index) => {
      const file = event.target.files[0];
      if (file) {
        images[index].previewUrl = URL.createObjectURL(file);
        images[index].file = file;
      }
    };

    function getProduit(id: number) {
      ApiService.get("/produits/" + id.toString())
        .then(({ data }) => {
          console.log(data.data, "datadatadatadatadatadatadatadata");
          for (const key in data.data) {
            produitForm.value?.setFieldValue(key, (typeof data.data[key] === 'object' && data.data[key] !== null) ? data.data[key].id : data.data[key]);
          }
          produitForm.value?.setFieldValue("famille", data.data["famille"].id)
          console.log("famille ===> ", data.data["famille"])
          famille.value = parseInt(data.data["famille"].id);
          //uniteGestion.value = parseInt(data.data["uniteGestion"].id);
          //uniteStock.value = parseInt(data.data["uniteStock"].id);
          produitForm.value?.setFieldValue("domaines", data.data["domaineproduits"].map((domaine) => domaine.domaineActivite.id));
          produitForm.value?.setFieldValue("uniteStock", data.data["uniteStock"].id + "|" + data.data["uniteStock"].valeur + "|" + data.data["uniteStock"].libelle);
          produitForm.value?.setFieldValue("uniteGestion", data.data["uniteGestion"].id + "|" + data.data["uniteGestion"].valeur + "|" + data.data["uniteGestion"].libelle);
          produitForm.value?.setFieldValue("codeProduit", "");
          produitForm.value?.setFieldValue("id", null);
          produitForm.value?.setFieldValue("imagePrincipal", null);
          delete  produitForm.value?.id;
          // if (data.data["imagePrincipal"] != null) {
          //   imagePreview.value = getUrlApiForProductFiles(data.data["imagePrincipal"]);
          // }
          if (data.data["produitchampslibres"] != null) {
            data.data["produitchampslibres"].forEach(element => {
              chamsdescritifs.push({
                id: parseInt(element.champslibre.id),
                libelleChamp: element.champslibre.libelleChamp,
                estObligatoire: element.champslibre.estObligatoire,
                typeChamp: element.champslibre.typeChamp,
                nomChamp: element.champslibre.nomChamp,
                valeur: element.valeur,
                idProChamp: null,
              });
            });

          }

          if (data.data["produitconditionnements"] != null) {
            data.data["produitconditionnements"].forEach(element => {
              conditionnements.push({
                conditionnement: element.conditionnement.id + "|" + element.conditionnement.valeur + "|" + element.conditionnement.libelle,
                quantite: element.qteCond,
                conditionnement2:  element.conditionnement2.id + "|" + element.conditionnement2.valeur + "|" + element.conditionnement2.libelle,
              });
            });

          }

          console.log("FOOROROROROROMMM ===> ", famille.value)
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }


    const addRowImage = () => {
      images.push({
        file: null,
        previewUrl: null,
      });
    };

    const removeRowConditionnement = (index) => {
      if (conditionnements.length > 1) conditionnements.splice(index, 1);
      //totals();
    };

    const removeRowImage = (index) => {
      if (images.length > 1) images.splice(index, 1);
      //totals();
    };

    const valideteRowProduit = (e) => {
      if (e == "" || e == 0 || e == "" || e == "0" || e == null || e < 0) {
        return true;
      } else {
        return false;
      }
    };

       const isPrixMinInvalid=(conditionnement=>{
      if(conditionnement.prixMin !=null && conditionnement.prixVente !=null){
        return conditionnement.prixMin > conditionnement.prixVente;
      }
      return false;
    })

    const isPrixMaxInvalid=(conditionnement=>{
      if(conditionnement.prixMax !=null && conditionnement.prixVente !=null){
        return conditionnement.prixMax < conditionnement.prixVente;
      }
      return false;
    })

    const modeDefPrix = ref("");
    const selectGroupe = (value) => {
      console.log(value, "valuevaluevaluevalue");
      if (parseInt(value.split("|")[1]) > 0) {
        modeDefPrix.value = "TTC(Toutes Taxes Comprises)";
      } else {
        modeDefPrix.value = "HT(Hors Taxes)";
      }
    }

    
      //  const calculePrix = (prix: number,produit:any) => {
      //   const taux = groupe.value.split('|')[2];
      //   console.log("valllll",taux);

        
      //   let prixHT = prix;
      //   let prixTTC = prix;
        
      //   if(mode.value === 'HT' ) {
      //     prixHT = prix;
      //     prixTTC = prixHT * (1 + parseInt(taux) / 100);
      //   } else if (mode.value === 'TTC') {
      //     prixTTC = prix;
      //     prixHT = prixTTC / (1 + parseInt(taux) / 100);
      //   }
        
      //   produit.prixHT =prixHT,
      //   produit.prixTTC =prixTTC
      //   console.log("calcul",produit);
      // };
    

      // const calculePrix = (prix: number, produit: any) => {
      //   const taux = groupe.value.split('|')[2];
      //   const code = groupe.value.split('|')[1];

      //   let prixHT = prix;
      //   let prixTTC = prix;

      //   if (code === 'D') {
      //     prixHT = prix;
      //     prixTTC = prixHT * (1 + parseInt(taux) / 100);
      //   } else if (mode.value === 'HT') {
      //     prixHT = prix;
      //     prixTTC = prixHT * (1 + parseInt(taux) / 100);
      //   } else if (mode.value === 'TTC') {
      //     prixTTC = prix;
      //     prixHT = prixTTC / (1 + parseInt(taux) / 100);
      //   }

      //   produit.prixHT = prixHT;
      //   produit.prixTTC = prixTTC;
      // };

      const calculePrix = (prix: number, produit: any) => {
  const taux = groupe.value.split('|')[2];
  const code = groupe.value.split('|')[1];
  
  console.log("🔍 DEBUG calculePrix:");
  console.log("  groupe.value:", groupe.value);
  console.log("  code:", code);
  console.log("  taux:", taux);
  console.log("  mode:", mode.value);
  console.log("  prix saisi:", prix);
  
  let prixHT = prix;
  let prixTTC = prix;

  // Pour tous les groupes (y compris D), respecter le mode de saisie
  if (mode.value === 'HT') {
    prixHT = prix;
    prixTTC = prixHT * (1 + parseInt(taux) / 100);
    console.log("  📊 Calcul HT: prixTTC =", prixHT, "* (1 +", taux, "/ 100) =", prixTTC);
  } else if (mode.value === 'TTC') {
    prixTTC = prix;
    prixHT = prixTTC / (1 + parseInt(taux) / 100);
    console.log("  📊 Calcul TTC: prixHT =", prixTTC, "/ (1 +", taux, "/ 100) =", prixHT);
  }

  produit.prixHT = prixHT;
  produit.prixTTC = prixTTC;
  
  console.log("  ✅ Résultat: prixHT =", prixHT, ", prixTTC =", prixTTC);
};


    const selectFamille = (value) => {
      console.log(value, "valuevaluevaluevalue");
      if (parseInt(value) > 0) {
        fetchAllChamps(parseInt(value));
      } else {
        chamsdescritifs.length = 0;
      }
    }

      watch(conditionnements, (newValue, oldValue) => {
  let isInvalid = false;
  Object.keys(newValue).forEach(function (key) {
    if (
      valideteRowProduit(newValue[key].conditionnement) ||
      valideteRowProduit(newValue[key].quantite) ||
      valideteRowProduit(newValue[key].prixVente) ||
       valideteRowProduit(newValue[key].prixMin) ||  
      valideteRowProduit(newValue[key].prixMax)  
    ) {
      isInvalid = true;
    } else if (
      newValue[key].prixMin != null &&
      newValue[key].prixVente != null &&
      parseFloat(newValue[key].prixMin) > parseFloat(newValue[key].prixVente)
    ) {
      isInvalid = true;
    } else if (
      newValue[key].prixMax != null &&
      newValue[key].prixVente != null &&
      parseFloat(newValue[key].prixMax) < parseFloat(newValue[key].prixVente)
    ) {
      isInvalid = true;
    } else {
    }
  });
  isDisable.value = isInvalid;
});


    watch(chamsdescritifs, (newValue, oldValue) => {
      const newValueLast = newValue.filter(order => order.estObligatoire == 1);
      console.log(newValueLast, "newValueLastnewValueLast");
      Object.keys(newValueLast).forEach(function (key) {
        if (newValueLast[key].valeur == "" || newValue[key].valeur == 0) {
          if (newValueLast[key].estObligatoire == 1) {
            isDisableCha.value = true;
            console.log(isDisableCha.value, "isDisableCha.value true");
          }
        } else {
          isDisableCha.value = false;
          console.log(isDisableCha.value, "isDisableCha.value false");
        }
      });
    });

    watch(images, (newValue, oldValue) => {
      Object.keys(newValue).forEach(function (key) {
        if (newValue[key].image == "") {
          isDisablee.value = true;
        } else {
          isDisablee.value = false;
        }
      });
    });


    const { remove, push, fields, update } = useFieldArray("conditionnements");



    const fetchConditionnements = async () => {
      try {
        const response = await axios.get("/conditionnements");
        const conditionnementsData = response.data.data;
        produitsss.value = conditionnementsData;
        conditionnementOptions.value = conditionnementsData.map((conditionnement) => ({
          value: conditionnement.id + "|" + conditionnement.valeur + "|" + conditionnement.libelle,
          label: `${conditionnement.libelle}`,
        }));
      } catch (error) {
        //
      }
    };

    const fetchConditionnementugs = async () => {
      try {
        const response = await axios.get("/conditionnementugs");
        const conditionnementgData = response.data.data;
        produitsss.value = conditionnementgData;
        conditionnementgOptions.value = conditionnementgData.map((conditionnement) => ({
          value: conditionnement.id + "|" + conditionnement.valeur + "|" + conditionnement.libelle,
          label: `${conditionnement.libelle}`,
        }));
      } catch (error) {
        //
      }
    };

    const fetchAllChamps = async (id) => {
      try {
        const response = await axios.get("/champsdescritif/famille/" + id);
        console.log(response.data, "response.dataresponse.dataresponse.data");
        chamsdescritifs.length = 0;
        response.data.data.forEach(element => {
          chamsdescritifs.push(element.champslibre);
        });
        console.log(chamsdescritifs, "chamsdescritifs.valuechamsdescritifs.value");

      } catch (error) {
        //
      }
    };

    const fetchProduis = async (newValue) => {
      try {
        const response = await ApiService.get(`produits/recherche?keyword=${newValue}&type=0`);
        console.log(response, "responseresponseresponseresponse");
        produitOptions.value = response.data.data;;
      } catch (error) {
        //
      }
    };

    const fetchSProduis = async (newValue) => {
      try {
        const response = await ApiService.get(`produits/recherche?keyword=${newValue}&type=1`);
        console.log(response, "responseresponseresponseresponse");
        produitStanOptions.value = response.data.data;;
      } catch (error) {
        //
      }
    };

    const fetchMProduis = async (newValue) => {
      try {
        const response = await ApiService.get(`produits/recherche?keyword=${newValue}&type=2`);
        console.log(response, "responseresponseresponseresponse");
        produitMarOptions.value = response.data.data;;
      } catch (error) {
        //
      }
    };

    const pays = [
      "Afghanistan",
      "Afrique du Sud",
      "Albanie",
      "Algérie",
      "Allemagne",
      "Andorre",
      "Angola",
      "Anguilla",
      "Antarctique",
      "Antigua-et-Barbuda",
      "Antilles Néerlandaises",
      "Arabie Saoudite",
      "Argentine",
      "Arménie",
      "Aruba",
      "Australie",
      "Autriche",
      "Azerbaïdjan",
      "Bahamas",
      "Bahreïn",
      "Bangladesh",
      "Barbade",
      "Bélarus",
      "Belgique",
      "Belize",
      "Bénin",
      "Bermudes",
      "Bhoutan",
      "Bolivie",
      "Bosnie-Herzégovine",
      "Botswana",
      "Brésil",
      "Brunéi Darussalam",
      "Bulgarie",
      "Burkina Faso",
      "Burundi",
      "Cambodge",
      "Cameroun",
      "Canada",
      "Cap-vert",
      "Chili",
      "Chine",
      "Chypre",
      "Colombie",
      "Comores",
      "Costa Rica",
      "Côte d'Ivoire",
      "Croatie",
      "Cuba",
      "Danemark",
      "Djibouti",
      "Dominique",
      "Égypte",
      "El Salvador",
      "Émirats Arabes Unis",
      "Équateur",
      "Érythrée",
      "Espagne",
      "Estonie",
      "États Fédérés de Micronésie",
      "États-Unis",
      "Éthiopie",
      "Fédération de Russie",
      "Fidji",
      "Finlande",
      "France",
      "Gabon",
      "Gambie",
      "Géorgie",
      "Géorgie du Sud et les Îles Sandwich du Sud",
      "Ghana",
      "Gibraltar",
      "Grèce",
      "Grenade",
      "Groenland",
      "Guadeloupe",
      "Guam",
      "Guatemala",
      "Guinée",
      "Guinée Équatoriale",
      "Guinée-Bissau",
      "Guyana",
      "Guyane Française",
      "Haïti",
      "Honduras",
      "Hong-Kong",
      "Hongrie",
      "Île Bouvet",
      "Île Christmas",
      "Île de Man",
      "Île Norfolk",
      "Îles (Malvinas) Falkland",
      "Îles Åland",
      "Îles Caïmanes",
      "Îles Cocos (Keeling)",
      "Îles Cook",
      "Îles Féroé",
      "Îles Heard et McDonald",
      "Îles Mariannes du Nord",
      "Îles Marshall",
      "Îles Mineures Éloignées des États-Unis",
      "Îles Salomon",
      "Îles Turks et Caïques",
      "Îles Vierges Britanniques",
      "Îles Vierges des États-Unis",
      "Inde",
      "Indonésie",
      "Irak",
      "Irlande",
      "Islande",
      "Israël",
      "Italie",
      "Jamahiriya Arabe Libyenne",
      "Jamaïque",
      "Japon",
      "Jordanie",
      "Kazakhstan",
      "Kenya",
      "Kirghizistan",
      "Kiribati",
      "Koweït",
      "L'ex-République Yougoslave de Macédoine",
      "Lesotho",
      "Lettonie",
      "Liban",
      "Libéria",
      "Liechtenstein",
      "Lituanie",
      "Luxembourg",
      "Macao",
      "Madagascar",
      "Malaisie",
      "Malawi",
      "Maldives",
      "Mali",
      "Malte",
      "Maroc",
      "Martinique",
      "Maurice",
      "Mauritanie",
      "Mayotte",
      "Mexique",
      "Monaco",
      "Mongolie",
      "Montserrat",
      "Mozambique",
      "Myanmar",
      "Namibie",
      "Nauru",
      "Népal",
      "Nicaragua",
      "Niger",
      "Nigéria",
      "Niué",
      "Norvège",
      "Nouvelle-Calédonie",
      "Nouvelle-Zélande",
      "Oman",
      "Ouganda",
      "Ouzbékistan",
      "Pakistan",
      "Palaos",
      "Panama",
      "Papouasie-Nouvelle-Guinée",
      "Paraguay",
      "Pays-Bas",
      "Pérou",
      "Philippines",
      "Pitcairn",
      "Pologne",
      "Polynésie Française",
      "Porto Rico",
      "Portugal",
      "Qatar",
      "République Arabe Syrienne",
      "République Centrafricaine",
      "République de Corée",
      "République de Moldova",
      "République Démocratique du Congo",
      "République Démocratique Populaire Lao",
      "République Dominicaine",
      "République du Congo",
      "République Islamique d'Iran",
      "République Populaire Démocratique de Corée",
      "République Tchèque",
      "République-Unie de Tanzanie",
      "Réunion",
      "Roumanie",
      "Royaume-Uni",
      "Rwanda",
      "Sahara Occidental",
      "Saint-Kitts-et-Nevis",
      "Saint-Marin",
      "Saint-Pierre-et-Miquelon",
      "Saint-Siège (État de la Cité du Vatican)",
      "Saint-Vincent-et-les Grenadines",
      "Sainte-Hélène",
      "Sainte-Lucie",
      "Samoa",
      "Samoa Américaines",
      "Sao Tomé-et-Principe",
      "Sénégal",
      "Serbie-et-Monténégro",
      "Seychelles",
      "Sierra Leone",
      "Singapour",
      "Slovaquie",
      "Slovénie",
      "Somalie",
      "Soudan",
      "Sri Lanka",
      "Suède",
      "Suisse",
      "Suriname",
      "Svalbard et Île Jan Mayen",
      "Swaziland",
      "Tadjikistan",
      "Taïwan",
      "Tchad",
      "Terres Australes Françaises",
      "Territoire Britannique de l'Océan Indien",
      "Territoire Palestinien Occupé",
      "Thaïlande",
      "Timor-Leste",
      "Togo",
      "Tokelau",
      "Tonga",
      "Trinité-et-Tobago",
      "Tunisie",
      "Turkménistan",
      "Turquie",
      "Tuvalu",
      "Ukraine",
      "Uruguay",
      "Vanuatu",
      "Venezuela",
      "Viet Nam",
      "Wallis et Futuna",
      "Yémen",
      "Zambie",
      "Zimbabwe"
    ];

    const selectConditionnement = async (value: any, conditionnement: any) => {
      console.log("Element", value);
      console.log("Objet", conditionnement.quantite);
      conditionnement.quantite = value.split("|")[1];
    };

    const getCurrentDate = () => {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      return `${year}-${month}-${day}`;
    };

    const addProduit = async (values, { resetForm }) => {
      console.log('Valeurs du formulaire :', values);
      console.log('Iff')
      values.conditionnements = conditionnements.map(conditionnement => ({
        conditionnement: conditionnement.conditionnement.split("|")[0],
        qteCond: conditionnement.quantite,
        prixMin:conditionnement.prixMin,
        prixVente:conditionnement.prixVente,
        prixMax:conditionnement.prixMax,
        conditionnement2: uniteGestion.value.split("|")[0],
        prixVenteTtc: conditionnement.prixTTC,
        prixVenteHt: conditionnement.prixHT,
        
      }));
      console.log("tkttt",values.conditionnements);
      values["uniteGestion"] = uniteGestion.value.split("|")[0]
      values["uniteStock"] = uniteStock.value.split("|")[0]
      values["groupe"] = groupe.value.split("|")[0];
      
      if (imageFile.value) {
        console.log(imageFile.value, "imageFile.value")
        values["imagePrincipal"] = imageFile.value;
      }

      values.champsdescritifs = chamsdescritifs.map(champsdescritif => ({
        champslibre: champsdescritif.id,
        valeur: champsdescritif.valeur,
      }));
      console.log('Les champs descriptifs ===> ', values);
      //values['images'] =  images.map(image => (image.file))
      // retirer urmImage du values
      delete values.urlImage;
      if (toutFichier.value.length > 0) {
        values['autreFichier[]'] = [];
        values['autreFichier[]'] = toutFichier.value.map((fichier) => (fichier));
      }

      console.log('Les fichiers ===> ', values["images"]);
      console.log('Mon FORMIULAIRE', values);

      ApiService.postWithFile("/produits", values)
        .then(({ data }) => {
          if (data.code == 201) {
            success(data.message);
            resetForm();
            router.push({ name: "ListeProduit" });
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };

    const fetchFamille = async () => {
      try {
        const response = await ApiService.get("all/all/familles");
        const familleData = response.data.data.data;
        console.log(familleData, "familleData");
        familleOptions.value = familleData.map((famille) => ({
          value: famille.id,
          label: `${famille.codeFamille} - ${famille.libelleFamille} ${famille.famille ? '(' + famille.famille.libelleFamille + ')' : ""}`,
        }));
      } catch (error) {
        //
      }
    };

    const fetchDomaines = async () => {
      try {
        const response = await ApiService.get("/domaines");
        const domainesData = response.data.data.data;
        console.log(domainesData, "domainesDatadomainesDatadomainesData");
        domaineOptions.value = domainesData.map((domaine) => ({
          value: domaine.id,
          label: `${domaine.code} - ${domaine.libelle}`,
        }));
      } catch (error) {
        //
      }
    };

    const fetchMarque = async () => {
      try {
        const response = await ApiService.get("all/all/marques");
        const marqueData = response.data.data.data;
        marqueOptions.value = marqueData.map((marque) => ({
          value: marque.id,
          label: marque.code,
        }));
      } catch (error) {
        //
      }
    };

    
 const fetchGroupeTaxe = async () => {
        try {
          const response = await ApiService.get("all/groupeTaxes");
          const groupeData = response.data.data.data;
          groupeOptions.value = groupeData.map((groupe) => ({
            value: `${groupe.id}|${groupe.code}|${groupe.taux}`,
            label: `${groupe.code} - ${groupe.libelle}`,
          }));
        } catch (error) {
          error('Erreur lors du chargement des groupes');
        }
      };

    const produitSchema = Yup.object().shape({
      //groupeTaxe: Yup.string().required("Le groupe de taxe est obligatoire"),
      // Champ retiré du formulaire : la marque n'est plus saisie
      marqProd: Yup.string().notRequired(),
      // modeDefPrix: Yup.string().required("Le mode de prix est obligatoire"),
      suiviStock: Yup.string().required("La méthode de suivi est obligatoire"),
      seuilAlerte: Yup.number()
        .required("Le seuil d'alerte est obligatoire")
        .min(0, "Le seuil d'alerte doit être positif")
        .test('seuil-alerte-superieur', 'Le seuil d\'alerte doit être supérieur ou égal au seuil de rupture', function(value) {
          const { seuilAppro } = this.parent;
          return !seuilAppro || !value || value >= seuilAppro;
        }),
      seuilAppro: Yup.number()
        .required("Le seuil de rupture est obligatoire")
        .min(0, "Le seuil de rupture doit être positif"),
      refProd: Yup.string().notRequired(),
      nomProd: Yup.string().required("Le nom est obligatoire"),
      nomStandar: Yup.string().notRequired(),
      nomMarche: Yup.string().notRequired(),
      imagePrincipal: Yup.string().notRequired(),
      famille: Yup.string().required("La famille est obligatoire"),
      uniteGestion: Yup.string().notRequired(),
      uniteStock: Yup.string().notRequired(),
      domaines: Yup.array().notRequired(),
      paysProduction: Yup.string().notRequired(),
      //estService: Yup.boolean().notRequired(),
      descProd: Yup.string().notRequired(),
      mode: Yup.string().required('Le mode de définition est obligatoire').oneOf(['HT', 'TTC'], 'Le mode doit être HT ou TTC'),
      groupe: Yup.string().required('Le groupe est obligatoire'),
    });


    
      const onGroupeSelect = (selectedGroupe: any) => {
        groupe.value = selectedGroupe;        
        const code = selectedGroupe.split('|')[1];
        if (code == 'B' || code == 'D') {
          estRedonly.value = false;
          mode.value = 'TTC';
           produitForm.value?.setFieldValue('mode', 'TTC');
        } else {
          estRedonly.value = true;
          mode.value = 'HT';
          produitForm.value?.setFieldValue('mode', 'HT'); 
        }
        produitForm.value?.setFieldValue('groupe', selectedGroupe)
      };


    const seletUniteGestion = (valeur) => {
      uniteGestion.value = valeur;
      conditionnements.length = 0;
      conditionnements.push({
        conditionnement: uniteGestion.value.split("|")[0],
        quantite: uniteGestion.value.split("|")[1],
        prixMin:null,
        prixVente:null,
        prixMax:null,
        conditionnement2: ""
      });
    }

    const uniteGestion = ref(null);
    const fileInput = ref(null);
    const imagePreview = ref(null);
    const imageFile = ref<File>(null);

    const triggerFileInput = () => {
      fileInput.value.click();
    };

    const onFilePrinChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        imageFile.value = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          imagePreview.value = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    };

    const removeImage = () => {
      imagePreview.value = null;
      imageFile.value = null;
    };

    onMounted(async () => {
      document.addEventListener('click', handleClickOutside);
      await fetchFamille();
      await fetchGroupeTaxe();
      await fetchConditionnements();
      await fetchConditionnementugs();
      await fetchMarque();
      await fetchDomaines();
      if (route.params.id) {
        console.log("ID from route params:", route.params.id);
        await getProduit(parseInt(route.params.id as string));
      }
    });

    onBeforeUnmount(() => {
      document.removeEventListener('click', handleClickOutside);
    });

    return {
      seletUniteGestion,
      produitOptions,
      uniteGestion,
      produitStanOptions,
      produitMarOptions,
      prodName,
      prodNameS,
      prodNameM,
      addProduit,
      hasFiles,
      produitForm,
      familleOptions,
      modeDefPrixOptions,
      groupeTaxeOptions,
      marqueOptions,
      methodeOptions,
      // magasinOptions,
      conditionnements,
      conditionnementgOptions,
      addRowImage,
      removeRowImage,
      removeRowConditionnement,
      addRowConditionnement,
      valideteRowProduit,
       isPrixMaxInvalid,
      isPrixMinInvalid,
      montantTotal,
      valuess,
      modeDefPrix,
      selectGroupe,
      images,
      conditionnementOptions,
      prixProd,
      selectConditionnement,
      isDisable,
      isDisablee,
      getCurrentDate,
      isDisableCha,
      //estService,
      onFileChange,
      dropzoneOptions,
      onFileAdd,
      onFileRemove,
      onSuccess,
      onError,
      defaultImage,
      chamsdescritifs,
      selectFamille,
      produitSchema,
      triggerFileInput,
      onFilePrinChange,
      removeImage,
      imagePreview,
      imageFile,
      fileInput,
      uniteStock,
      domaineOptions, pays,
      showBox, showBoxM, showBoxStan, dropdownRef, dropdownRef1, dropdownRef2
      ,groupeOptions,mode,onGroupeSelect,estRedonly,modeOptions,calculePrix

    };
  },
});
</script>

<style scoped>
.dropzone-container {
  position: relative;
  width: 100%;
  max-width: 500px;
  margin: auto;
}

.default-image-container {
  text-align: center !important;
  margin: 20px 0 !important;
}

.default-image {
  width: 100px !important;
  height: auto !important;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.marge-droite {
  margin-left: 15px;
}

.hr-longeur {
  width: 80%;
}

.bord1 {
  border: 1px solid #07a;
}

.fond {
  background-color: rgb(94, 191, 233);
}

@import 'dropzone-vue/dist/dropzone-vue.common.css';

.upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.preview-card {
  width: 100%;
  height: 222px;
  border: 2px dashed #cfd4e4;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  background: #f8f9fc;
  position: relative;
  color: #3D434A;
  transition: border-color 0.15s, background-color 0.15s;
}

.preview-card:hover {
  border-color: var(--theme-deafult);
  background: #eef0f8;
}

.preview-icon {
  font-size: 2rem;
  color: var(--theme-deafult);
}

/* ---- Mise en page du formulaire ---- */
.produit-form .card-body {
  padding: 24px;
}

.form-section {
  padding-bottom: 22px;
  margin-bottom: 22px;
  border-bottom: 1px solid #eef0f4;
}

.section-title {
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--theme-deafult);
  margin-bottom: 14px;
  padding-left: 10px;
  border-left: 3px solid var(--theme-deafult);
}

.form-label-produit {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: #3D434A;
  margin-bottom: 5px;
}

/* Suggestions de noms sous les champs */
.suggestions {
  position: absolute;
  z-index: 20;
  width: calc(100% - 12px);
  max-height: 220px;
  overflow-y: auto;
}

/* Onglets conditionnements / images */
.tab-cadre {
  border: 1px solid #dee2e6;
  border-top: none;
  padding: 18px;
  border-radius: 0 0 6px 6px;
}

.cond-entete {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #6c757d;
  background: #f5f6fa;
  padding: 8px 0;
  margin: 0;
  border-radius: 4px;
}

.cond-ligne {
  margin: 0;
  padding: 10px 0;
  border-bottom: 1px dashed #e5e7eb;
}

.cond-ligne:last-child {
  border-bottom: none;
}

/* Barre d'actions en bas */
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.preview-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.delete-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(220, 53, 69, 0.9);
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 14px;
}

.delete-btn:hover {
  background: #b02a37;
}
</style>
